export var TimeseriesChartKind;
(function (TimeseriesChartKind) {
    TimeseriesChartKind["TIMESERIES_CHART_KIND_UNSPECIFIED"] = "TIMESERIES_CHART_KIND_UNSPECIFIED";
    TimeseriesChartKind["TIMESERIES_CHART_KIND_LINE"] = "TIMESERIES_CHART_KIND_LINE";
    TimeseriesChartKind["TIMESERIES_CHART_KIND_BAR"] = "TIMESERIES_CHART_KIND_BAR";
})(TimeseriesChartKind || (TimeseriesChartKind = {}));
